import ReactDOM from 'react-dom/client'
import App from './containers/App'
import { Provider } from 'react-redux'
import { configureStore } from './store'
import { ThemeProvider } from '@xstyled/styled-components'
import theme from './theme'
import './index.css'
import './i18n'

const store = configureStore()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
)
